import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SKIP_INTERCEPTOR } from './skip-interceptor.token';

/**
 * Attaches an `Idempotency-Key` to state-changing POSTs — the frontend wiring contract (§7.6):
 * the backend replays it to dedup a retried request and 409s a concurrent duplicate. A per-request
 * UUID makes every POST contract-compliant and covers in-flight retries of the *same* request.
 *
 * (True double-submit protection — a key that's stable across separate user re-submits of one
 * logical operation — is a call-site follow-up: mint the key when the operation starts and pass it
 * on the retry. This interceptor is the baseline that guarantees presence.)
 *
 * Skipped for anything marked `SKIP_INTERCEPTOR` (S3 presigned uploads go straight to the bucket,
 * not our API) and for requests that already carry the header.
 */
export function idempotencyKeyInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  if (req.method !== 'POST' || req.context.get(SKIP_INTERCEPTOR) || req.headers.has('Idempotency-Key')) {
    return next(req);
  }
  return next(req.clone({ setHeaders: { 'Idempotency-Key': crypto.randomUUID() } }));
}
